"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
exports.clamp = (value, min, max) => Math.min(Math.max(value, min), max);
